<script>
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Caja from "../../Components/UI/Caja.svelte";
    import CampoDeTexto from "../../Components/UI/CampoDeTexto.svelte";

    import validate from 'validate.js';
    import Boton from "../../Components/UI/Boton.svelte";
    import usuario from '../../Stores/usuario-store';
    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import {goto} from '@sveltech/routify';

    const constraints = {
        email: {
            presence: {
                allowEmpty: false,
                message: 'es obligatorio'
            }
        },
        clave: {
            presence: {
                allowEmpty: false,
                message: 'es obligatorio'
            }
        },
    };

    let email = '';
    let clave = '';

    $: errores = validate({email: email, clave: clave}, constraints) || {};
    $: error = $usuario.error;

    const iniciaSesion = () => usuario.login(email, clave).then(() => $goto('/'));
</script>

<Titulo>Inicio de sesión</Titulo>

<Caja>
    <div slot="titulo"><h2>Introduce tu usuario</h2></div>

    <form on:submit|preventDefault={iniciaSesion}>
        <CampoDeTexto id="email" label="E-mail" value={email} icono="alternate_email"
                      valido={!errores.email} mensajeDeError={errores.email}
                      on:input={e => email = e.target.value}/>

        <CampoDeTexto id="clave" label="Clave" value={clave} icono="lock_open"
                      type="password" valido={!errores.clave} mensajeDeError={errores.clave}
                      on:input={e => clave = e.target.value}/>

        <div style="display: none">
            <button disabled={Object.keys(errores).length && !$usuario.enviando} type="submit"></button>
        </div>
    </form>

    <div slot="pie">
        {#if $usuario.cargando}
            <Loading/>
        {:else}
            <Boton on:click={iniciaSesion} disabled={Object.keys(errores).length && !$usuario.enviando}>
                Entrar
            </Boton>
        {/if}
    </div>
</Caja>

{#if error}
    <Error on:cancel={() => error = null}>{error}</Error>
{/if}